import GetAlerts from './homepage/features/GetAlerts.svg';
import AskCommunity  from './homepage/features/AskCommunity.svg';
import TreePermits   from './homepage/features/TreePermits.svg';
import UnderConstruction from './homepage/features/UnderConstructions.svg'

var features = [{
    titleKey: 'discoverPlanning',
    image: GetAlerts,
    id: '5960526241a5a',
    backgroundColor: '#E4FAFF'
}, {
    titleKey: 'createAlerts',
    image: UnderConstruction,
    id: 'a924af4248469',
    backgroundColor: '#F7F2FF'
}, {
    titleKey: 'savePlans',
    image: AskCommunity,
    id: '52a94356d662a',
    backgroundColor: ' #FFFAE9'
}, {
    titleKey: 'treePermits',
    image: TreePermits,
    id: '12a43c3c66da9',
    backgroundColor: '#E7FFF9'
}];

export default features;